// extracted by mini-css-extract-plugin
export default {"ItemSpacing":"LocaleSection_ItemSpacing__dIU+j","LinkItem":"LocaleSection_LinkItem__v71Tk"};